import { v4 as uuid } from "uuid";
import { isDefined } from "./functions";

export const createKey = (): string => uuid();

export const getLocationOrigin = (): string => {
  if (window.location.origin.includes("localhost")) {
    return `https://www-t.storebrand.no`;
  }
  return window.location.origin;
};

export const isIterable = (object: any): boolean => {
  if (!object) {
    return false;
  }
  return typeof object[Symbol.iterator] === "function";
};

export const removeLineBreaks = (text: string): string =>
  text.replace(/(\r\n|\n|\r)/gm, "");

export const positiveNumberOr0 = (n?: number): number => {
  if (!n) {
    return 0;
  }
  return n < 0 ? 0 : n;
};

export function hasProperty<
  R extends Record<string | number | symbol, unknown>,
  P extends string | number | symbol,
>(
  record: R,
  property: P,
): record is R &
  Record<P, P extends keyof R ? Exclude<R[P], undefined | null> : unknown> {
  return isDefined(record[property]);
}
